'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _modules = require('./modules');

var _modules2 = _interopRequireDefault(_modules);

var _redux = require('redux');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// This is for integrating with the Redux Devtool Chrome/Firefix extension:
// https://github.com/zalmoxisus/redux-devtools-extension
var devToolExtension = window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__();

exports.default = function () {
  return (0, _redux.createStore)(_modules2.default, devToolExtension);
};